//imports
import {
    IMPORT_P4_EXCEPTION_DETAILS_OPEN_MODAL,
    IMPORT_P4_EXCEPTION_SEARCH_DETAILS_REQUEST,
    IMPORT_P4_EXCEPTION_SEARCH_DETAILS_RESULT,
    IMPORT_P4_EXCEPTION_GET_DETAILS_REQUEST,
    IMPORT_P4_EXCEPTION_GET_DETAILS_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    exceptions: [],
    account: null,
    details: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case IMPORT_P4_EXCEPTION_DETAILS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, account: action.payload.account }

        case IMPORT_P4_EXCEPTION_SEARCH_DETAILS_REQUEST:
            return { ...state, loading: true }

        case IMPORT_P4_EXCEPTION_SEARCH_DETAILS_RESULT:
            return { ...state, loading: false, exceptions: action.payload }

        case IMPORT_P4_EXCEPTION_GET_DETAILS_REQUEST:
            return { ...state, loading: true }

        case IMPORT_P4_EXCEPTION_GET_DETAILS_RESULT:
            return { ...state, loading: false, details: action.payload }

        case CLEAR_REDUX:
            return ["", "EXCEPTION_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};